module.exports = "/_next/static/images/Hero@2x-2a75d628f55374b775e5a37d428a85ac.webp";